const constants = {
    certificateURL: 'https://businesstoys.in/verify-certificate/#/',
    // baseURL: 'http://localhost:9000/api/student',
    baseURL: 'https://app.businesstoys.in/api/student',
    header: 'LYuIQAYzwkcGOAbuBjZqlEjTmVCJyrvEDZqnhOnmDGFwsvSVZN'
}

export default constants;